// extracted by mini-css-extract-plugin
export default {"root":"erU5Yx","iconHolder":"S4RhJs","title":"hJcIQs","text":"nUtMns","boldText":"h6ACkK","closeButton":"VVHbO_","buttons":"_8P24af","nextReviewRequest":"rFIetB"};